export enum BankConnectionErrorType {
  ShineConnect = 'ShineConnect',
  ShineMerge = 'ShineMerge',
  OpenBankingConnect = 'OpenBankingConnect',
  OpenBankingMerge = 'OpenBankingMerge',
}
